import { render } from "./UsersView.vue?vue&type=template&id=60cbd4b6&scoped=true"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"

import "./UsersView.vue?vue&type=style&index=0&id=60cbd4b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cbd4b6"]])

export default __exports__